import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import * as dateUtils from "../../utils/date";

import {
  modalController
} from "../../actions/domActions";

import {
  setAllUntracked
} from "../../actions/historyActions";

import { HistoryContext, SortDirection } from "../../props";

import Context from "./Context";

export function Provider({ children, endDate, historyContext, initialDate, sortDir, startDate, openDateFilterPickerModal, setAllUntracked }) {
  const dateFilter = useDateFilter({ historyContext, openDateFilterPickerModal, setAllUntracked });

  const allUntracked = historyContext === "todo" && initialDate && startDate === initialDate && endDate === null;

  const state = useMemo(() => ({
    allUntracked,
    endDate,
    historyContext,
    initialDate,
    sortDir,
    startDate,
    openDateFilterPickerModal,
    dateFilter,
  }), [allUntracked, endDate, historyContext, initialDate, sortDir, startDate, openDateFilterPickerModal, dateFilter]);

  return (
    <Context.Provider value={state}>
      {children}
    </Context.Provider>
  );
}

Provider.displayName = "History.Provider";

Provider.propTypes = {
  endDate: PropTypes.string,
  historyContext: HistoryContext.isRequired,
  initialDate: PropTypes.string,
  openDateFilterPickerModal: PropTypes.func.isRequired,
  setAllUntracked: PropTypes.func.isRequired,
  sortDir: SortDirection.isRequired,
  startDate: PropTypes.string,
};

Provider.defaultProps = {
  historyContext: "todo",
  sortDir: "asc"
};

function mapStateToProps(state, ownProps) {
  return {
    endDate: state.historyFilters.endDate,
    historyContext: state.historyFilters.context,
    initialDate: state.historyFilters.initialDate,
    startDate: state.historyFilters.startDate,
    sortDir: state.historyFilters.sortDir,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    openDateFilterPickerModal: () => dispatch(modalController("DATE_FILTER_PICKER")),
    setAllUntracked() {
      dispatch(setAllUntracked());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Provider);

function useDateFilter(config) {
  const options = useDateFilterOptions(config);

  return useMemo(() => ({
    options,
  }), [options]);
}

function useDateFilterOptions({ historyContext, openDateFilterPickerModal, setAllUntracked }) {
  return useMemo(() => {
    const options = [
      days(7),
      days(30),
      days(90),
      days(365),
      {
        id: "calendar-month",
        label: "Calendar Month",
        value: () => dateUtils.calendarMonth()
      }, {
        id: "fiscal-quarter",
        label: "Mentor Fiscal Quarter",
        value: () => dateUtils.fiscalQuarter()
      }, {
        id: "fiscal-year",
        label: "Mentor Fiscal Year",
        value: () => dateUtils.fiscalYear()
      }, {
        id: "custom-date-range",
        label: "Custom Date Range...",
        selectHandler: () => openDateFilterPickerModal()
      }
    ];

    if (historyContext === "todo") {
      options.splice(options.length - 1, 0, {
        id: "all-untracked",
        label: "All Untracked",
        selectHandler: () => setAllUntracked()
      });
    }

    return options;
  }, [historyContext, openDateFilterPickerModal, setAllUntracked]);
}

function days(dayCount) {
  return {
    id: `last-${dayCount}-days`,
    label: `Last ${dayCount} Days`,
    value: () => dateUtils.daysAgo(dayCount)
  };
}



// WEBPACK FOOTER //
// ./app/components/History/Provider.jsx